import { UserRound, Sunrise, MessageCircle, Sparkles, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

const ICONS = [UserRound, Sunrise, MessageCircle, Sparkles, ShieldCheck];

export function TrustStrip() {
  const { lang } = useLanguage();
  const items = CONTENT[lang].trust;

  return (
    <section className="border-y border-navy/10 bg-ivory" data-testid="trust-strip">
      <div className="mx-auto max-w-7xl px-5 py-8 sm:px-8">
        <div className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-5">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={item}
                delay={i * 60}
                className="flex items-center gap-2.5 lg:flex-col lg:items-center lg:gap-2 lg:text-center"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold/12 text-gold ring-1 ring-gold/25">
                  <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
                </span>
                <span className="text-[13px] font-medium leading-tight text-navy/80">{item}</span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
